// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ONUC","col":"styles_col__1igkR"};